import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SALES_SESSION_DEBIT_NOTES_COLUMNS } from '../../../../config/columns';
import {
  clearSalesSessionDebitNotes,
  getSalesSessionDebitNotes,
} from '../../../../actions';
import Table from '../../../common/Table';
import { filterMethodCaseInsensitive } from '../../../../utils/filter-methods';

const DebitNotesTable = ({
  loading,
  salesSessionId,
  salesSessionDebitNotes,
  dispatchClearSalesSessionDebitNotes,
  dispatchGetSalesSessionDebitNotes,
}) => {
  useLayoutEffect(() => {
    dispatchGetSalesSessionDebitNotes({ salesSessionId });

    return () => {
      dispatchClearSalesSessionDebitNotes();
    };
  }, []);

  const data = salesSessionDebitNotes.toJS();

  return (
    <>
      <Table
        columns={SALES_SESSION_DEBIT_NOTES_COLUMNS}
        data={data}
        showPagination
        manual={false}
        loading={loading}
        filterable
        defaultFilterMethod={filterMethodCaseInsensitive}
      />
      <br />
    </>
  );
};

DebitNotesTable.propTypes = {
  salesSessionId: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchGetSalesSessionDebitNotes: PropTypes.func.isRequired,
  dispatchClearSalesSessionDebitNotes: PropTypes.func.isRequired,
  salesSessionDebitNotes: PropTypes.instanceOf(Object),
};

DebitNotesTable.defaultProps = {
  salesSessionDebitNotes: [],
};

const mapStateToProps = ({ SalesUnit }) => ({
  salesSessionDebitNotes: SalesUnit.SalesSessionDebitNote.getIn([
    'all',
    'content',
  ]),
  loading: SalesUnit.SalesSessionDebitNote.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetSalesSessionDebitNotes: getSalesSessionDebitNotes,
  dispatchClearSalesSessionDebitNotes: clearSalesSessionDebitNotes,
};

export default connect(mapStateToProps, mapDispatchToProps)(DebitNotesTable);
